import React, { Component } from 'react'
import { connect } from 'react-redux';
import { postReportRequestGenByCall } from '../../store/actions/projectActions'
import { get } from 'lodash'
import Loader from 'react-loader-spinner';

class ReportModal extends Component {
    state = {
        selectedTagList: [],
        hasAllTags: true,
        tagList: [],
    }
    /// README: Compare to sort
    compare(a, b) {
        if ('name' in a && 'name' in b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        }
        return 0;
    };
    componentDidMount() {
        const { userData, snagDetail, commons } = this.props;
        // console.log(snagDetail)
        const { deletedTagCategoryKey } = commons;
        const ueid = userData.uid + userData.employeeid;
        var tagList = Object.values(snagDetail['allTagsMap']).sort(this.compare).filter(val => (val.tagid !== "elevation")).filter(val => !val.name.includes(deletedTagCategoryKey));
        const selectedTagsIdList = snagDetail['accessMap'][`${ueid}`]['selectedTagsIdList'];
        const imHasAllTags = snagDetail['accessMap'][`${ueid}`]['hasAllTags'];
        if (!imHasAllTags) {
            tagList = tagList.filter(val => selectedTagsIdList.includes(val.tagid))
        }
        this.setState({
            tagList,
        })

    }
    handleRequest = (e) => {
        const { selectedTagList, hasAllTags, tagList } = this.state;
        const { userData, snagDetail } = this.props;
        var newSelectedTagList = [];
        if (hasAllTags) {
            newSelectedTagList = [...newSelectedTagList, ...tagList.map(e => e.tagid)];
        }
        else {
            newSelectedTagList = [...newSelectedTagList, ...selectedTagList];
        }
        if (newSelectedTagList.length === 0) {
            alert('please attach a category to continue');
        }
        else {
            newSelectedTagList = [...newSelectedTagList, "elevation"];
            this.props.postReportRequestGenByCall(userData, newSelectedTagList, snagDetail);
        }

    }
    handleChange = (e) => {
        const { selectedTagList } = this.state;
        const currentTagid = e.target.id;
        if (selectedTagList.includes(currentTagid)) {
            this.setState({
                selectedTagList: selectedTagList.filter(val => val !== currentTagid),
            })
        }
        else {
            this.setState({
                selectedTagList: [...selectedTagList, currentTagid],
            })
        }


    }
    handleNoChange = (e) => {

    }
    handleChangeSelectAll = (e) => {
        const { hasAllTags, selectedTagList } = this.state;
        const newHasAllTags = !hasAllTags;

        this.setState({
            hasAllTags: newHasAllTags,
            selectedTagList: newHasAllTags === false ? selectedTagList : []
        })

    }

    render() {
        const { modalTitleStyle, themeColors, project, modalInfoTextStyle, commons } = this.props;
        const { isReportCreating, papiMessage, isReportCreated } = project;
        const { selectedTagList, hasAllTags, tagList } = this.state;
        const textStyle = {
            color: themeColors.darkThemeColor,
        }
        const [internalMemberLimitMessage, externalMemberLimitMessage, tagCountLimitMessage] = papiMessage.split('.');
        // console.log(papiMessage)
        // console.log(internalMemberLimitMessage,"in",externalMemberLimitMessage,"ex",tagCountLimitMessage,"tg")
        const importantMessage = !isReportCreated ? <React.Fragment /> : <p style={{ color: "#a20000" }}><br />{internalMemberLimitMessage}
            <br />{externalMemberLimitMessage}<br />{tagCountLimitMessage}</p>
        const relevantSubmitComponent = isReportCreating ?
            <button className="btn btn-flat btn-dark btn-sm" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp; Creating report
            </button> : 
            // (<button className="btn btn-flat btn-sm border-dark" style={{ borderRadius: '10px' }} type="submit" onClick={this.handleRequest}>Generate report</button>);
        (<div className="btn btn-dark btn-sm" style={{ borderRadius: '9px' }} type="submit" onClick={this.handleRequest}>Generate report</div>);
        return (

            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">

                    <div className="d-flex justify-content-between" style={{ marginTop: '35px' }}>
                        <div className="" style={{ textAlign: 'start' }}>
                            <h5 style={modalTitleStyle}>Report generation</h5>
                            <p style={modalInfoTextStyle}>Select the tag {commons.tagCategories} and generate the report</p>
                        </div>
                        <div className="align-self-start" style={{ paddingRight: '10px', textAlign: 'start' }}>
                            {relevantSubmitComponent}
                        </div>

                    </div>


                    <div className="">
                        <div className="checkbox" >
                            <label className="m-2" htmlFor="selectAll" style={{ fontSize: '16px', fontWeight: 'normal' }}><input type="checkbox" id="selectAll" checked={hasAllTags} onChange={this.handleChangeSelectAll} /><b> Select all</b></label>
                        </div>
                        {tagList.map(val => {
                            return (
                                <div className="checkbox" key={val.tagid}>

                                    <label style={{ fontSize: '14px', color: 'grey', fontWeight: '' }} className="m-2" htmlFor={val.tagid}>
                                        <input type="checkbox" checked={hasAllTags || selectedTagList.includes(val.tagid)} id={val.tagid} onChange={hasAllTags ? this.handleNoChange : this.handleChange} />  {val.name}</label>
                                </div>
                            )
                        })}

                    </div>
                    <br />
                    {importantMessage}

                </div>
            </div>


        )
    }
}


const mapStateToProps = (state) => {
    // console.log(state.project)
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        alu: state.alu,
        modalStyles: state.appControl.modalStyles,

        floor: state.floor,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        postReportRequestGenByCall: (userModelJson, specificTagList, projectModelJson) => dispatch(postReportRequestGenByCall(userModelJson, specificTagList, projectModelJson)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ReportModal)

